import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IApiResponse } from '../api-response';
import { ApiVersion } from '../api-versions';
import { DataHttpCommonService } from '../data-http-common.service';
import { EndpointUrlConfig } from '../endpoint.config';
import type { IEndpointUrlConfig } from '../endpoint.config';
import { IGetReportsCriteria, ReportsDataHttpService } from './abstract';
import type { IGetReportsResult } from './abstract';
import { excludeUndefinedProps } from '@valhalla/utils';

@Injectable()
export class ReportsDataHttpServiceImpl implements ReportsDataHttpService {
	constructor(
		@Inject(EndpointUrlConfig) public readonly config: IEndpointUrlConfig,
		public readonly http: HttpClient,
		public readonly common: DataHttpCommonService
	) {}

	getReports(criteria?: IGetReportsCriteria): Observable<IGetReportsResult> {
		const url = this.common.getApiUrl(`reports`, ApiVersion.v10);
		return this.http
			.get<IApiResponse<IGetReportsResult>>(url, {
				headers: {
					['background-request']: 'true',
				},
				params: excludeUndefinedProps({ contextType: criteria?.contextType }),
			})
			.pipe(map(result => result.data));
	}
}
